import { render, staticRenderFns } from "./TenantDetailsTabs.vue?vue&type=template&id=38eb849c&scoped=true"
import script from "./TenantDetailsTabs.vue?vue&type=script&lang=js"
export * from "./TenantDetailsTabs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38eb849c",
  null
  
)

export default component.exports